import { render } from "./selectCreateType.vue?vue&type=template&id=570a5f8d&scoped=true"
import script from "./selectCreateType.vue?vue&type=script&lang=js"
export * from "./selectCreateType.vue?vue&type=script&lang=js"

import "./selectCreateType.vue?vue&type=style&index=0&id=570a5f8d&lang=scss"
import "./selectCreateType.vue?vue&type=style&index=1&id=570a5f8d&scoped=true&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570a5f8d"]])

export default __exports__